import * as React from 'react'

import Router from './components/Layout/Router'
import SessionStore from './stores/sessionStore'
import SignalRAspNetCoreHelper from './lib/signalRAspNetCoreHelper'
import Stores from './stores/storeIdentifier'
import { inject } from 'mobx-react'
import withSplashScreen from '@components/Layout/SplashScreen'
import ChangePasswordModal from '@components/Layout/Header/MyProfile/components/changePasswordModal'
import { portalLayouts, userLayout } from '@components/Layout/Router/router.config'
import AppConsts from '@lib/appconst'

declare var abp: any

export interface IAppProps {
  location: any
  history: any
  sessionStore?: SessionStore
}

@inject(Stores.SessionStore)
class App extends React.Component<IAppProps> {
  state = {
    needLoginStep: undefined,
    showChangePasswordModal: false,
    isInitialized: false,
    shouldRender: false
  }

  async componentDidMount() {
    try {
      const currentPath = window.location.pathname
      const isAuthPage = 
        currentPath.startsWith('/account/') || 
        currentPath.startsWith('/public/')
      
      // If on auth page, allow rendering immediately (no token check needed)
      if (isAuthPage) {
        this.setState({ shouldRender: true })
        return
      }

      // Token check is already done in SplashScreen, but double-check here for safety
      // Check if we have a token (should be true if we reached here and not on auth page)
      let hasToken = false
      try {
        hasToken = !!abp?.auth?.getToken() || 
                   !!abp?.utils?.getCookieValue?.(AppConsts.authorization.encrptedAuthTokenName)
      } catch (e) {
        // If abp is not ready and not on auth page, redirect
        window.location.href = userLayout.landingPage.path
        return
      }

      // If no token and not on auth page, redirect (shouldn't happen due to SplashScreen check, but safety net)
      if (!hasToken) {
        window.location.href = userLayout.landingPage.path
        return
      }

    // Only fetch user info if we have a token
    if (hasToken) {
      try {
        await this.props.sessionStore!.getCurrentLoginInformations()
        
        // Check if user is authenticated after API call
        if (
          !this.props.sessionStore!.currentLogin.user &&
          !isAuthPage
        ) {
          window.location.href = userLayout.landingPage.path
          return // Page will redirect, don't continue
        }

        // alway taget to report user if  href is /
        if (
          this.props.sessionStore!.currentLogin.user &&
          window.location.pathname === '/'
        ) {
          window.location.pathname = portalLayouts.reportUser.path
        }
        if (
          this.props.sessionStore!.currentLogin.user &&
          !this.props.sessionStore!.currentLogin.user?.userInfo?.isEmailConfirmed
        ) {
          this.setState({ showChangePasswordModal: true })
        }

        if (
          !!this.props.sessionStore!.currentLogin.user &&
          this.props.sessionStore!.currentLogin.application.features['SignalR']
        ) {
          if (
            this.props.sessionStore!.currentLogin.application.features[
              'SignalR.AspNetCore'
            ]
          ) {
            SignalRAspNetCoreHelper.initSignalR()
          }
        }
      } catch (error) {
        // If API call fails (e.g., token expired), redirect to landing page
        if (!isAuthPage) {
          window.location.href = userLayout.landingPage.path
          return // Page will redirect, don't continue
        }
      }
    }

      // Mark as initialized and allow rendering only if we're not redirecting
      this.setState({ isInitialized: true, shouldRender: true })
    } catch (error) {
      // If there's an error during initialization, allow the app to render
      // ErrorBoundary will catch any rendering errors
      console.error('Error in App componentDidMount:', error)
      this.setState({ isInitialized: true, shouldRender: true })
    }
  }

  public render() {
    // Don't render Router until we've checked token and determined we should render
    // This prevents double loading
    if (!this.state.shouldRender) {
      return null
    }

    return (
      <>
        <Router />
        <ChangePasswordModal
          visible={this.state.showChangePasswordModal}
          onCancel={() =>
            this.setState({
              showChangePasswordModal: false
            })
          }
          onCreate={() =>
            this.setState({
              showChangePasswordModal: false
            })
          }
        />
      </>
    )
  }
}

export default withSplashScreen(App)
